import { createFileRoute, Navigate } from '@tanstack/react-router';

import { CrmCustomerProfilePage } from '@pages/crm';
import { useCrmCustomerRecordRouteGuard } from '@widgets/crm-customer-record-shell';

export const Route = createFileRoute('/$locale/_authenticated/crm/user-profiles/$userProfileId/')({
  component: CrmCustomerOverviewRoute,
});

function CrmCustomerOverviewRoute() {
  const fallback = useCrmCustomerRecordRouteGuard('overview');
  const params = Route.useParams();
  const search = Route.useSearch();
  if (fallback !== null)
    return (
      <Navigate to={fallback.route} params={params} search={search} replace resetScroll={false} />
    );
  return <CrmCustomerProfilePage />;
}
